











import { Component, Vue } from 'vue-property-decorator'
import TedsLauncherTopBar from '../TedsLauncherTopBar/TedsLauncherTopBar.vue'
import TedsLauncherIconMenu from '../TedsLauncherIconMenu/TedsLauncherIconMenu.vue'
import TedsLauncherContent from '../TedsLauncherContent/TedsLauncherContent.vue'
import TedsLauncherMenu from '../TedsLauncherMenu/TedsLauncherMenu.vue'

@Component({
  components: {
    TedsLauncherTopBar,
    TedsLauncherIconMenu,
    TedsLauncherContent,
    TedsLauncherMenu,
  },
})
export default class TedsLauncherLayout extends Vue {}
